import { Component } from "react";

import "./style.scss";

class CheckBox extends Component {
    render() {
        return (
            <label className={`custom-checkbox ${this.props.className}`}>{this.props.label}
                <input type="checkbox" name="checkbox" onChange={this.props.onChange} />
                <span className="checkmark"></span>
            </label>
        )
    }
}

export default CheckBox;